import React from 'react';
import classNames from 'classnames';
import ActionFilter from './components/ActionFilter';
import MemberFilter from './components/MemberFilter';
import DateFilter from './components/DateFilter';
import { NAVIGATION_VARIANTS, NavigationVariants } from 'models/Navigation';
import QAFilter from './components/QaFilter/QaFilter.component';
import ClearFilters from 'components/ClearFilters';
import useNumberOfResultsPerPage from 'hooks/useNumberOfResultsPerPage';
import NumberOfResultsPerPageFilter from 'components/NumberOfResultsPerPageFilter';
import useMatchMedia from 'hooks/useMatchMedia';

import './ReportsFilters.styles.scss';

type ReportsFiltersProps = {
  className?: string;
  variant?: NavigationVariants;
};

const ReportsFilters: React.FC<ReportsFiltersProps> = (props) => {
  const { className, variant = NAVIGATION_VARIANTS.SECONDARY } = props;

  const classes = classNames('reports-filters', className);

  const { limit, updateLimit } = useNumberOfResultsPerPage();

  const renderAsPortal = !useMatchMedia('isPhablet');

  return (
    <div className={classes}>
      <MemberFilter variant={variant} renderAsPortal={renderAsPortal} />
      <ActionFilter variant={variant} renderAsPortal={renderAsPortal} />
      <QAFilter variant={variant} renderAsPortal={renderAsPortal} />
      <DateFilter variant={variant} renderAsPortal={renderAsPortal} />
      <NumberOfResultsPerPageFilter
        limit={limit}
        variant={variant}
        renderAsPortal={renderAsPortal}
        updateLimit={updateLimit}
      />
      <ClearFilters />
    </div>
  );
};

export default ReportsFilters;
